import NormalizeText from "../normalizeValues/NormalizeText";

const ObtenerMultiplicador = ({pais, paises}) => {
  if (!pais || !paises) {
    return 0;
  }
  const paisNormalizado = NormalizeText(pais);
  const clientCountry = paises?.find((p) => NormalizeText(p.name) === paisNormalizado)
  
  // Validar que clientCountry existe antes de acceder a sus propiedades
  if (!clientCountry) {
    console.log("País no encontrado en la lista de países")
    return 0;
  }
  
  const multiplicador = (clientCountry.increasePercentage - clientCountry.discountPercentage) || 0;
  return multiplicador || 0;
}

export default ObtenerMultiplicador;
